import script from "./FormulasPreviewPrize.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasPreviewPrize.vue?vue&type=script&setup=true&lang=js"

import "./FormulasPreviewPrize.vue?vue&type=style&index=0&id=a7ad473e&lang=scss"

const __exports__ = script;

export default __exports__